import React from "react";
import { styled } from "styled-components";
import { CloseWhite } from "../../assets/icons";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";

const RideInfoModal = ({ setRideInfo }) => {

  const handleOnClose = () => {
    setRideInfo(false);
  };

  return (
    <MainContainer>
      <CloseImage src={CloseWhite} onClick={() => handleOnClose()} />
      <InfoTitle>{Text.mapInfoTitle}</InfoTitle>
      <InfoDetail>
        {Text.mapInfoDetail}
        <span>{Text.mapHashtagText}</span>
      </InfoDetail>
    </MainContainer>
  );
};

const MainContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 105%;
  right: 50%;
  background-color: #0261a3;
  color: #fff;
  border-radius: 0.25rem;
  transition: opacity 0.3s;
  cursor: pointer;
  width: 70%;
  padding: 1rem;
  z-index: 1000;
  @media only screen and (max-width: 1024px) {
    width: 45%;
    right: 0;
    left: 0;
  }
  @media only screen and (max-width: 540px) {
    width: 85%;
  }
`;
const CloseImage = styled.img`
  height: 1.25rem;
  width: 1.25rem;
  position: absolute;
  top: 1rem;
  right: 1rem;
`;
const InfoTitle = styled.span`
  color: ${Colors.white};
  font-size: 1.125rem;
  font-weight: 700;
  margin-top: 0.5rem;
`;
const InfoDetail = styled.span`
  color: ${Colors.white};
  font-size: 1rem;
  font-weight: 400;
  text-align: justify;
  > span {
    font-style: italic;
    font-weight: 500;
    color: #dde9f4;
  }
`;

export default RideInfoModal;
